import ImagesCursor, { ImageCursor, LERPS, OPA } from './ImagesCursor';

export default class ImagesCursorIndex extends ImagesCursor {
    constructor(__container = document.body, __holder = document.body, __class = Ima) {
        super(__container, __holder);
    }

    calculateIndex() { }
}

export class ImageCursorIndex extends ImageCursor {
    constructor(__container, __i, __total) {
        super(__container, __i, __total);
    }

    switchOrder() {
        const relativeIndex = (this._index - this._current + this._total) % this._total;

        if (relativeIndex < this._item_visible) {
            this._factor = LERPS[this._item_visible - 1 - relativeIndex];
            this._opacity = OPA[this._item_visible - 1 - relativeIndex];
            this._container.style.zIndex = this._item_visible - 1 - relativeIndex;

            this.show();
        } else {
            this.hide();
        }
    }
}
